module.exports = __webpack_public_path__ + "img/logo.4f5a72ac.png";